import React from "react";
import logo from "../assets/NHL_logo.png";
import avatar from "../assets/avatar.png";
import "./LoginPage.css";
import ProfileDropdown from "../components/ProfileDropdown";

function StudentDashboard() {
  const [info, setInfo] = React.useState(null);

  // files
  const [refl, setRefl] = React.useState(null);
  const [thes, setThes] = React.useState(null);
  const [first, setFirst] = React.useState(null);
  const [company, setCompany] = React.useState(null);

  // needed components
  const [submission, setSubmission] = React.useState(null);
  const [courses, setCourses] = React.useState(null);
  const [examiners, setExaminers] = React.useState(null);
  const [isPendingSubmission, setPendingSubmission] = React.useState(null);
  const [feedback, setFeedback] = React.useState(null);
  const [reviewed, setReviewed] = React.useState(null);
  const [gradFormId, setGradFormId] = React.useState(null);

  // form stuff
  const [courseId, setCourseId] = React.useState(0);
  const [firstExaminer, setFirstExaminer] = React.useState(0);
  const [secondExaminer, setSecondExaminer] = React.useState(0);
  const [companyName, setCompanyName] = React.useState("");
  const [supervisorName, setSupervisorName] = React.useState("");
  const [resit, setResit] = React.useState(false);

  async function uploadFile(file, type) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    try {
      await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${submission.id}/files/upload`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
    } catch (e) {
      console.error(e);
    }
  }

  async function downloadFeedback() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${submission.id}/files/download/${feedback.id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      let filename = "download.pdf";
      const disposition = response.headers.get("Content-Disposition");
      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
    }
  }

  async function downloadGradForm() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${reviewed.id}/files/download/${gradFormId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      let filename = "download.pdf";
      const disposition = response.headers.get("Content-Disposition");
      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
    }
  }

  async function downloadPreset() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${submission.id}/files/download/preset/supervisor`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      let filename = "download.pdf";
      const disposition = response.headers.get("Content-Disposition");
      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
    }
  }

  const postSubmission = async (e) => {
    e.preventDefault();
    const submissionData = {
      course_id: Number(courseId),
      first_examiner: Number(firstExaminer),
      second_examiner: Number(secondExaminer),
      company_name: companyName,
      supervisor_name: supervisorName,
      resit: Boolean(resit),
    };
    try {
      let response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
          body: JSON.stringify(submissionData),
        }
      );

      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }

      window.location.reload();
    } catch (e) {
      console.error(e);
    }
  };

  const submitSubmission = async (e) => {
    try {
      let response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${submission.id}/submit`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }

      window.location.reload();
    } catch (e) {
      console.error(e);
    } finally {
      window.location.reload();
    }
  };

  React.useEffect(() => {
    const getInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/profile`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }
      const parseRes = await response.json();

      if (parseRes?.isExaminer === true) {
        window.location.href = "/exsubmissions";
        return;
      }

      setInfo(parseRes);
    };
    getInfo();
  }, []);

  React.useEffect(() => {
    const getSubmissions = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }
      const parseRes = await response.json();

      let reviewed = parseRes.find(
        (submission) => submission.status === "closed"
      );

      if (reviewed) {
        setReviewed(reviewed);
      }

      let submission = parseRes.find(
        (submission) =>
          submission.status === "submittable" ||
          submission.status === "first_draft_submitted"
      );

      if (!submission) {
        setSubmission({});
      } else {
        setSubmission(submission);
        setReviewed(null);
        return;
      }

      submission = parseRes.find(
        (submission) => submission.status === "pending"
      );

      if (!submission) {
        setSubmission({});
        setPendingSubmission(false);
      } else {
        setSubmission(submission);
        setPendingSubmission(true);
      }
    };
    getSubmissions();
  }, []);

  React.useEffect(() => {
    const getCourses = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/courses`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }
      const parseRes = await response.json();
      setCourses(parseRes);
    };
    getCourses();
  }, []);

  React.useEffect(() => {
    const getExaminers = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/examiners`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }
      const parseRes = await response.json();
      setExaminers(parseRes);
    };
    getExaminers();
  }, []);

  React.useEffect(() => {
    const getFeedback = async () => {
      if (submission?.id === undefined) return;
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${submission?.id}/files/list/details`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }

      let parseRes = await response.json();

      parseRes = parseRes.filter(
        (file) => file.type === "First Draft Feedback"
      );

      setFeedback(parseRes[0]);
    };
    getFeedback();
  }, [submission]);

  React.useEffect(() => {
    const getGradFormId = async () => {
      if (reviewed?.id === undefined) return;
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/${reviewed?.id}/files/list`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }

      let parseRes = await response.json();

      parseRes = parseRes.filter((file) => file.type === "combined_form");

      setGradFormId(parseRes[0].id);
    };
    getGradFormId();
  }, [reviewed]);

  if (!info || !courses || !examiners || !submission) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <h2 className="text-xl font-bold mb-2">Onstage</h2>
        <p className="text-sm text-gray-600 mb-4">Loading your data...</p>
        <svg
          className="animate-spin h-10 w-10 text-gray-600"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            fill="none"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 008 8V4a8 8 0 00-8 8z"
          />
        </svg>
      </div>
    );
  }

  return (
    <div>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>NHL Stenden Project Management</title>
      <header className="bg-white border-b border-gray-200">
        <nav className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <img className="h-20 w-auto" src={logo} alt="NHL Stenden" />
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-3">
                <img className="h-8 w-8 rounded-full" src={avatar} alt="" />
                <span className="text-sm font-medium text-gray-700">
                  {info?.name}
                </span>
                <ProfileDropdown user={info} />
              </div>
            </div>
          </div>
        </nav>
      </header>
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">
            Student Dashboard
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            Manage your final project submissions{" "}
          </p>
          {submission?.id === undefined && (
            <div className="alert alert-error mt-4">
              <div className="alert-content">
                <div className="icon-container">
                  <i className="fas fa-error"></i>
                </div>
                <div className="alert-message">
                  <p>
                    You have not gotten any active submissions. Please, submit
                    the infromation below first.
                  </p>
                </div>
              </div>
            </div>
          )}
          {isPendingSubmission && (
            <div className="alert alert-success mt-4">
              <div className="alert-content">
                <div className="icon-container">
                  <i className="fas fa-warning"></i>
                </div>
                <div className="alert-message">
                  <p>
                    You have a pending submission. Please, wait for the
                    evaluation.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
        {feedback !== null && feedback !== undefined && (
          <div className="mb-8 bg-white rounded-lg shadow p-5">
            <h2 className="text-lg font-medium text-gray-900 mb-4">
              Review Documents & Submit Revision
            </h2>

            <div className="">
              <div className="mb-6 bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                <h3 className="text-sm font-medium text-yellow-800 mb-2">
                  Examiner Feedback
                </h3>
                <p className="text-sm text-yellow-700">
                  Please review the feedback provided and submit your revised
                  documents.
                </p>
              </div>

              <div className="mb-6">
                <h3 className="text-sm font-medium text-gray-700 mb-3">
                  Examiner Documents
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div className="flex items-center">
                      <i className="fa-regular fa-file-pdf text-gray-400 text-xl mr-3" />
                      <span className="text-sm text-gray-700">
                        {feedback?.type} - {feedback?.name}
                      </span>
                    </div>
                    <button
                      className="text-custom hover:text-custom/80 text-sm font-medium"
                      onClick={() => downloadFeedback()}
                    >
                      <i className="fa-solid fa-download mr-1" /> Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {reviewed !== null && reviewed !== undefined && (
          <div className="mb-8 bg-white rounded-lg shadow p-5">
            <h2 className="text-lg font-medium text-gray-900 mb-4">
              Review Your Documents
            </h2>

            <div className="">
              <div className="mb-6 bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                <h3 className="text-sm font-medium text-yellow-800 mb-2">
                  Examiner Feedback
                </h3>
                <p className="text-sm text-yellow-700">
                  Please review the feedback provided.
                </p>
              </div>

              <div className="mb-6">
                <h3 className="text-sm font-medium text-gray-700 mb-3">
                  Examiner Documents
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div className="flex items-center">
                      <i className="fa-regular fa-file-pdf text-gray-400 text-xl mr-3" />
                      <span className="text-sm text-gray-700">
                        {info?.name} - Graduation Assessment Form
                      </span>
                    </div>
                    <button
                      className="text-custom hover:text-custom/80 text-sm font-medium"
                      onClick={() => downloadGradForm()}
                    >
                      <i className="fa-solid fa-download mr-1" /> Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="bg-white rounded-lg shadow">
          <div className="p-6">
            <div className="mb-8">
              <h2 className="text-lg font-medium text-gray-900 mb-4">
                Document Submission
              </h2>
            </div>
            <form className="space-y-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Course
                  </label>
                  <select
                    className="mt-1 block w-full border-gray-300 rounded-md shadow-sm py-3 px-4 text-base"
                    onChange={(e) => setCourseId(e.target.value)}
                    disabled={submission?.id !== undefined}
                  >
                    <option value hidden>
                      Select Course
                    </option>
                    {courses?.map((course) => (
                      <option
                        value={course.id}
                        key={course.id}
                        selected={submission?.course_id === course.id}
                      >
                        {course.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    First Examiner
                  </label>
                  <select
                    className="mt-1 block w-full border-gray-300 rounded-md shadow-sm py-3 px-4 text-base"
                    onChange={(e) => setFirstExaminer(e.target.value)}
                    disabled={submission?.id !== undefined}
                  >
                    <option value hidden>
                      Select First Examiner
                    </option>
                    {examiners?.map((examiner) => (
                      <option
                        value={examiner.id}
                        key={examiner.id}
                        selected={submission?.first_examiner_id === examiner.id}
                      >
                        {examiner.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Second Examiner
                  </label>
                  <select
                    className="mt-1 block w-full border-gray-300 rounded-md shadow-sm py-3 px-4 text-base"
                    onChange={(e) => setSecondExaminer(e.target.value)}
                    disabled={submission?.id !== undefined}
                  >
                    <option value hidden>
                      Select Second Examiner
                    </option>
                    {examiners?.map((examiner) => (
                      <option
                        value={examiner.id}
                        key={examiner.id}
                        selected={
                          submission?.second_examiner_id === examiner.id
                        }
                      >
                        {examiner.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Company Name
                  </label>
                  <input
                    type="text"
                    className="mt-1 block w-full border-gray-300 rounded-md shadow-sm py-3 px-4 text-base"
                    placeholder="Enter company name"
                    onChange={(e) => setCompanyName(e.target.value)}
                    value={submission ? submission.company : companyName}
                    disabled={submission?.id !== undefined}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Company Supervisor
                  </label>
                  <input
                    type="text"
                    className="mt-1 block w-full border-gray-300 rounded-md shadow-sm py-3 px-4 text-base"
                    placeholder="Enter supervisor name"
                    onChange={(e) => setSupervisorName(e.target.value)}
                    value={
                      submission
                        ? submission?.company_supervisor
                        : supervisorName
                    }
                    disabled={submission?.id !== undefined}
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Attempt Type
                </label>
                <select
                  className="mt-1 block w-full border-gray-300 rounded-md shadow-sm py-3 px-4 text-base"
                  onChange={(e) => setResit(e.target.value)}
                  disabled={submission?.id !== undefined}
                >
                  <option value={false} selected={!submission?.resit}>
                    First Attempt
                  </option>
                  <option value={true} selected={submission?.resit}>
                    Resit
                  </option>
                </select>
              </div>
              <div className="flex justify-end">
                <button
                  type="submit"
                  className={
                    submission?.id !== undefined
                      ? "cursor-not-allowed rounded-md bg-gray-300 text-black px-4 py-2 text-sm font-medium"
                      : "rounded-md bg-black text-white px-4 py-2 text-sm font-medium hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black"
                  }
                  onClick={postSubmission}
                  disabled={submission?.id !== undefined}
                >
                  Create a submission
                </button>
              </div>

              <div className="text-holder relative">
                {isPendingSubmission && (
                  <div className="absolute inset-0 flex items-center justify-center z-10">
                    <span className="text-lg font-medium text-gray-700 bg-white px-4 py-2 rounded-md shadow">
                      Files are submitted. Nothing to submit
                    </span>
                  </div>
                )}
                {(!submission?.id || isPendingSubmission === false) && (
                  <div className="absolute inset-0 flex items-center justify-center z-10">
                    <span className="text-lg font-medium text-gray-700 bg-white px-4 py-2 rounded-md shadow">
                      Create a submission first
                    </span>
                  </div>
                )}
                <div
                  className={`file-upload ${
                    !submission?.id || isPendingSubmission
                      ? "opacity-50 pointer-events-none blur-sm"
                      : ""
                  }`}
                >
                  <div>
                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          First Draft (PDF, optional)
                        </label>
                        <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                          {submission.status === "submittable" ? (
                            <div className="space-y-1 text-center">
                              <i className="fa-solid fa-cloud-arrow-up text-gray-400 text-3xl mb-3" />
                              <div className="flex text-sm text-gray-600">
                                <label className="relative cursor-pointer rounded-md font-medium text-custom hover:text-custom focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-custom">
                                  <span>
                                    {first ? first.name : "Upload a file"}
                                  </span>
                                  <input
                                    type="file"
                                    multiple={false}
                                    className="sr-only"
                                    accept=".pdf"
                                    onChange={(e) => {
                                      setFirst(e.target.files[0]);
                                    }}
                                  />
                                </label>
                                <p className="pl-1">
                                  {thes ? "to be uploaded" : "or drag and drop"}
                                </p>
                              </div>
                              <p className="text-xs text-gray-500">
                                PDF up to 10MB
                              </p>
                            </div>
                          ) : (
                            <div className="space-y-1 text-center">
                              <p className="pl-1">First draft is submitted</p>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex justify-end">
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            uploadFile(first, "first_draft").then(() => {
                              window.location.reload();
                            });
                          }}
                          type="submit"
                          disabled={first === null}
                          className={
                            first === null
                              ? "cursor-not-allowed rounded-md bg-gray-300 text-black px-4 py-2 text-sm font-medium"
                              : "rounded-md bg-black text-white px-4 py-2 text-sm font-medium hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black"
                          }
                        >
                          Submit First draft
                        </button>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Thesis Document (PDF)
                      </label>
                      <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                        <div className="space-y-1 text-center">
                          <i className="fa-solid fa-cloud-arrow-up text-gray-400 text-3xl mb-3" />
                          <div className="flex text-sm text-gray-600">
                            <label className="relative cursor-pointer rounded-md font-medium text-custom hover:text-custom focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-custom">
                              <span>{thes ? thes.name : "Upload a file"}</span>
                              <input
                                type="file"
                                multiple={false}
                                className="sr-only"
                                accept=".pdf"
                                onChange={(e) => {
                                  setThes(e.target.files[0]);
                                }}
                              />
                            </label>
                            <p className="pl-1">
                              {thes ? "to be uploaded" : "or drag and drop"}
                            </p>
                          </div>
                          <p className="text-xs text-gray-500">
                            PDF up to 10MB
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="mt-3">
                      <label className="block text-sm font-medium text-gray-700">
                        Reflection and Evaluation (PDF)
                      </label>
                      <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                        <div className="space-y-1 text-center">
                          <i className="fa-solid fa-cloud-arrow-up text-gray-400 text-3xl mb-3" />
                          <div className="flex text-sm text-gray-600">
                            <label className="relative cursor-pointer rounded-md font-medium text-custom hover:text-custom focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-custom">
                              <span>{refl ? refl.name : "Upload a file"}</span>
                              <input
                                type="file"
                                multiple={false}
                                className="sr-only"
                                accept=".pdf"
                                onChange={(e) => {
                                  setRefl(e.target.files[0]);
                                }}
                              />
                              <input
                                type="file"
                                className="sr-only"
                                accept=".pdf"
                              />
                            </label>
                            <p className="pl-1">or drag and drop</p>
                          </div>
                          <p className="text-xs text-gray-500">
                            PDF up to 10MB
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="mt-10">
                      <div className="flex">
                        <label className="block text-sm font-medium text-gray-700 pt-1.5">
                          Supervisor's Feedback (PDF)
                        </label>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            downloadPreset();
                          }}
                          className="px-4 py-2 ml-5 text-sm font-medium text-black bg-green-400 rounded-md shadow-sm hover:bg-green-300"
                        >
                          Download preset
                        </button>
                      </div>
                      <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                        <div className="space-y-1 text-center">
                          <i className="fa-solid fa-cloud-arrow-up text-gray-400 text-3xl mb-3" />
                          <div className="flex text-sm text-gray-600">
                            <label className="relative cursor-pointer rounded-md font-medium text-custom hover:text-custom focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-custom">
                              <span>
                                {company ? company.name : "Upload a file"}
                              </span>
                              <input
                                type="file"
                                multiple={false}
                                className="sr-only"
                                accept=".pdf"
                                onChange={(e) => {
                                  setCompany(e.target.files[0]);
                                }}
                              />
                              <input
                                type="file"
                                className="sr-only"
                                accept=".pdf"
                              />
                            </label>
                            <p className="pl-1">or drag and drop</p>
                          </div>
                          <p className="text-xs text-gray-500">
                            PDF up to 10MB
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-end">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        uploadFile(thes, "thesis").then(() => {
                          uploadFile(refl, "reflection").then(() => {
                            uploadFile(company, "company_supervisor").then(
                              () => {
                                submitSubmission();
                              }
                            );
                          });
                        });
                      }}
                      type="submit"
                      disabled={
                        refl === null || thes === null || company === null
                      }
                      className={
                        refl === null || thes === null || company === null
                          ? "cursor-not-allowed rounded-md bg-gray-300 text-black px-4 py-2 text-sm font-medium mt-4"
                          : "rounded-md bg-black text-white px-4 py-2 text-sm font-medium hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black"
                      }
                    >
                      Submit Documents
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <footer className="bg-white border-t border-gray-200 mt-12">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-4 text-center text-sm text-gray-500">
            <p>© 2024 NHL Stenden. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default StudentDashboard;
